import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { authGuard } from './guards/auth.guard';
import { HomePageComponent } from './pages/home-page/home-page.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginLayoutComponent,
        children: [
            { path: '', component: LoginPageComponent },
        ]
    },
    {
        canActivate: [authGuard],
        path: '',
        component: MainLayoutComponent,
        children: [
            { path: 'home', component: HomePageComponent },
            {
                path: 'users',
                loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
            },
            {
                path: 'reservations',
                loadChildren: () => import('./modules/reservation/reservation.module').then(m => m.ReservationModule)
            },
            {
                path: 'agencies',
                loadChildren: () => import('./modules/agency/agency.module').then(m => m.AgencyModule)
            },
            {
                path: 'deposits',
                loadChildren: () => import('./modules/deposit/deposit.module').then(m => m.DepositModule)
            },
            {
                path: 'deposit-mv',
                loadChildren: () => import('./modules/deposit-mv/deposit-mv.module').then(m => m.DepositMvModule)
            },
            {
                path: 'availability',
                loadChildren: () => import('./modules/availability/availability.module').then(m => m.AvailabilityModule)
            }
        ]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
];
